import { render, staticRenderFns } from "./delivery-point.vue?vue&type=template&id=6586754c&scoped=true"
import script from "./delivery-point.vue?vue&type=script&lang=js"
export * from "./delivery-point.vue?vue&type=script&lang=js"
import style0 from "./delivery-point.vue?vue&type=style&index=0&id=6586754c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586754c",
  null
  
)

export default component.exports